"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardedContainer = void 0;
var react_1 = __importDefault(require("react"));
var AuthenticationContext_1 = require("./AuthenticationContext");
/**
 * A container component that will render its children only when the authentication
 * context has the appropriate permissions.
 *
 * Note that UI guarding must be accompanied with API guarding. UI guarding is subject
 * to manipulation through changing the state or the code with development tools.
 *
 * @param props
 */
var GuardedContainer = function (props) {
    var requiredPermissions = props.requiredPermissions, notAllowedRender = props.notAllowedRender, children = props.children;
    return (react_1.default.createElement(AuthenticationContext_1.AuthenticationContext.Consumer, null, function (_a) {
        var permissions = _a.permissions;
        // Note that we don't need to test if we're logged in or not. By
        // default the AuthenticationContext will have an empty permission
        // set for a non logged in state.
        var isAllowed = requiredPermissions.every(function (requiredPermission) {
            return permissions.includes(requiredPermission);
        });
        return isAllowed ? children : (notAllowedRender && notAllowedRender()) || null;
    }));
};
exports.GuardedContainer = GuardedContainer;
//# sourceMappingURL=GuardedContainer.js.map